// tslint:disable:no-any

import * as React from 'react';
import DiveMap from '../components/DiveMap';
import {
    DisplayDiveMode,
    DisplayDepth,
    DisplayGPS,
    DisplaySac,
    DisplayNdash
} from '../components/Display';

export interface IDiveDataCardsProps {
    shared: boolean;
    dive: any;
}

interface IDiveDataCardsState {
    dive: any;
    center: { lat: any; lng: any };
    point: { lat: any; lng: any };
    zoom: number;
    shared: boolean;
    showAlert: boolean;
}

export default class DiveDataCards extends React.Component<
    IDiveDataCardsProps,
    IDiveDataCardsState
> {
    constructor(props: IDiveDataCardsProps) {
        super(props);

        let sac = props.dive.diveAndMixes.dive.sac;

        this.state = {
            dive: props.dive,
            center: {
                lat: props.dive.diveAndMixes.dive.latitude,
                lng: props.dive.diveAndMixes.dive.longitude
            },
            point: { lat: null, lng: null },
            zoom: 10,
            shared: props.shared,
            showAlert:
                sac.isInvalid || sac.isIncomplete || sac.sourceDataIncomplete
        };
    }

    componentDidMount() {
        this.setState({
            point: {
                lat: this.state.dive.diveAndMixes.dive.latitude,
                lng: this.state.dive.diveAndMixes.dive.longitude
            }
        });
    }

    prepareStatValues() {
        let dive = this.state.dive.diveAndMixes.dive;

        return [
            {
                name: 'Location',
                value:
                    dive.location === null || dive.location === '' ? (
                        <DisplayNdash />
                    ) : (
                        this.state.dive.diveAndMixes.dive.location
                    ),
                type: 'location',
                className: ''
            },
            {
                name: 'GPS',
                value: (
                    <DisplayGPS
                        lat={this.state.dive.diveAndMixes.dive.latitude}
                        lng={this.state.dive.diveAndMixes.dive.longitude}
                    />
                ),
                type: 'location',
                className: ''
            },
            {
                name: 'Max. depth',
                value: (
                    <DisplayDepth
                        data={this.state.dive.diveAndMixes.dive.maxDepth}
                    />
                ),
                type: 'maxDepth',
                className: ''
            },
            {
                name: 'Average depth',
                value: (
                    <DisplayDepth
                        data={
                            Math.round(
                                this.state.dive.diveAndMixes.dive.averageDepth *
                                    100
                            ) / 100
                        }
                    />
                ),
                type: 'averageDepth',
                className: ''
            },
            {
                name: 'Dive time',
                value: this.state.dive.diveAndMixes.dive.duration,
                type: 'time',
                className: ''
            },
            {
                name: 'Start mode',
                value:
                    this.state.dive.diveData.startMode === null ? (
                        <DisplayNdash />
                    ) : (
                        <DisplayDiveMode
                            data={this.state.dive.diveData.startMode}
                        />
                    ),
                type: 'air',
                className: ''
            },
            {
                name: 'Site',
                value:
                    dive.site === null || dive.site === '' ? (
                        <DisplayNdash />
                    ) : (
                        this.state.dive.diveAndMixes.dive.site
                    ),
                type: 'site',
                className: ''
            },
            {
                name: 'SAC',
                value:
                    this.state.shared === true ? (
                        <DisplayNdash />
                    ) : (
                        <DisplaySac
                            data={this.state.dive.diveAndMixes.dive.sac.value}
                            sac={this.state.dive.diveAndMixes.dive.sac}
                            alert={this.state.showAlert}
                        />
                    ),
                type: 'air',
                className: this.state.shared === true ? ' shared' : ''
            }
        ];
    }

    // tslint:disable-next-line:no-empty
    onMapClick(e: Event) {}

    render() {
        let data = this.prepareStatValues();

        return (
            <section className="dive__dataCards cf">
                <div
                    className={
                        'dive__stats cf' +
                        (this.state.point.lat === null &&
                        this.state.point.lng === null
                            ? ' fourCols'
                            : '')
                    }
                >
                    <div className="dive__stats__subholder">
                        {data.map((stat, index) => (
                            <div
                                key={index}
                                className={`statCard statCard--${stat.type}${
                                    stat.className
                                }`}
                            >
                                <div className="holder__table">
                                    <div className="holder__cell">
                                        <h3>{stat.name}</h3>
                                        <span>{stat.value}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {this.state.point.lat !== null &&
                    this.state.point.lng !== null && (
                        <div className="dive__miniMap">
                            <DiveMap
                                diveData={this.state.dive.diveAndMixes.dive}
                                point={this.state.point}
                                center={this.state.center}
                                zoom={this.state.zoom}
                                startupZoom={this.state.zoom}
                                shared={this.state.shared}
                                onMapClick={e => this.onMapClick(e as any)}
                            />
                        </div>
                    )}
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DiveDataCards.tsx